import type { DeviceContext } from "../lib/device";
import {
  derivePwaReadiness,
  type PwaCaptureFlags,
} from "./pwa-readiness";

// PWA readiness card (GW-PWA-READINESS) - the operational top strip of the Field Status screen:
// four glanceable rows, no controls, no tutorial wall. Presentational only; every fact arrives
// derived (or via the injectable detectors), so this never touches browser APIs in render.

export function PwaReadiness({
  device,
  captureFlags,
  serviceWorkerActive,
  storageAvailable,
  notificationsEnabled,
}: {
  device: DeviceContext;
  captureFlags: PwaCaptureFlags;
  serviceWorkerActive: boolean;
  storageAvailable: boolean;
  notificationsEnabled: boolean;
}) {
  const items = derivePwaReadiness({ device, serviceWorkerActive, storageAvailable, captureFlags, notificationsEnabled });
  return (
    <div className="pwaready" role="group" aria-label="App readiness">
      <h3 className="pwaready__title">App readiness</h3>
      <dl className="pwaready__list">
        {items.map((item) => (
          <div key={item.key} className="pwaready__row">
            <dt className="pwaready__label">{item.label}</dt>
            <dd className={`pwaready__value pwaready__value--${item.tone}`}>{item.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
